export const formattedDate = (date: Date | undefined): string | undefined => {
  return (
    date &&
    new Date(date).toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
  );
};

export const formattedDateWithMonthName = (date: Date | undefined): string | undefined => {
  return (
    date &&
    new Date(date)
      .toLocaleDateString('de-DE', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      })
      .replace('.', '')
  );
};
